<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/program-mgt">Program Management </a>
            </li>
            <li class="breadcrumb-item">Add</li>
        </ol>
        <div class="order-view mt30 mrgn-0-auto">
            <form [formGroup]="addProgramForm">
                <div class="main-block-innner">
                    <div class="input-style">

                        <!-- **********************Subadmin profile image ****************  -->


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Program Type:</h6>
                            </label>
                            <div class="col-md-7">
                                <select name="" formControlName="programType"
                                    (change)="programTypeChange($event.target.value)" class="custom-select form-control"
                                    id="">
                                    <option value="">Select Program Type</option>
                                    @for (item of programTypeList; track item; let i = $index) {
                                    <option value="{{item?.programType}}">
                                        {{item?.programType}}</option>
                                    }

                                </select>
                                @if(addProgramForm.get('programType')?.hasError('required') &&
                                addProgramForm.get('programType')?.dirty){
                                <span>
                                    <small class="text-danger">*Program Type is required.</small>
                                </span>
                                }
                            </div>
                        </div>



                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Title :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" placeholder="Title" formControlName="title"
                                    maxlength="256" (keypress)="service.passwordKeyPress($event)" minlength="2">
                                @if(addProgramForm.get('title')?.hasError('required') &&
                                addProgramForm.get('title')?.dirty){
                                <span>
                                    <small class="text-danger">*Title is required.</small>
                                </span>
                                }
                            </div>
                        </div>


                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Amount :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" [readonly]="IsFree" class="form-control" placeholder="Amount($)"
                                    formControlName="amount" (keypress)="service.inputKeyPress($event)" maxlength="10">
                                @if(addProgramForm.get('amount')?.hasError('required')&&
                                addProgramForm.get('amount')?.dirty){
                                <span>
                                    <small class="text-danger">*Amount is required.</small>
                                </span>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Therapist Session :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" formControlName="therapistSession"
                                    placeholder="Therapist Session" maxlength="2"
                                    (keypress)="service.inputKeyPress($event)">


                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Medical Session :</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" formControlName="MedicalSession" maxlength="2"
                                    placeholder="Medical Session" (keypress)="service.inputKeyPress($event)">

                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6> Case Manager Session:</h6>
                            </label>
                            <div class="col-md-7">
                                <input type="text" class="form-control" formControlName="CaseManager"
                                    placeholder="Case Manager Session" (keypress)="service.inputKeyPress($event)"
                                    maxlength="2">
                            </div>
                        </div>
                        <div class="form-group row align-items-center mb-3">
                            <label class="col-md-5">
                                <h6>Is insurance package?</h6>
                            </label>
                            <div class="col-md-7">
                                <label class="md-check">
                                    <input type="radio" value="Yes" name="isInsurancePackage"
                                        formControlName="isInsurancePackage">
                                    Yes
                                </label>
                                &nbsp;
                                &nbsp;
                                <label class="md-check">
                                    <input type="radio" value="No" name="isInsurancePackage"
                                        formControlName="isInsurancePackage">
                                    No
                                </label>
                            </div>
                        </div>
                        <div class="form-group row align-items-center">
                            <label class="col-md-5">
                                <h6> Description: </h6>
                            </label>
                        </div>
                        <div class="row">
                            <div class="col">
                                <ckeditor rows="5" ngSkipHydration formControlName="description" maxlength="1000"
                                    [editorUrl]="'//://cdn.ckeditor.com'">
                                </ckeditor>
                                @if(addProgramForm.get('description')?.hasError('required')&&
                                addProgramForm.get('description')?.dirty){
                                <span>
                                    <small class="text-danger">*Description is required.</small>
                                </span>
                                }
                                @if(addProgramForm.get('description')?.hasError('maxlength')&&
                                addProgramForm.get('description')?.dirty){
                                <span>
                                    <small class="text-danger">*Description must be less than 1000 character.</small>
                                </span>
                                }
                            </div>
                        </div>

                        <div class="text-center mt-3">
                            <button class="btn btn-theme" [disabled]="addProgramForm.invalid"
                                (click)="addProgram()">Save</button>
                            <button class="btn btn-danger" style="margin-left: 20px;min-width: 100px;"
                                routerLink="/program-mgt">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</main>